import { gql } from "@apollo/client";

const GET_INVOICES = gql`
  query GetInvoices(
    $params: QueryParams
    $client: ID
    $location: ID
  ) {
      invoices(params: $params
      client: $client
      location: $location
    ) {
      info {
        count
      }
      results {
        id
        status
        client {
          id
          fiscalData {
            rfc
          }
          user {
            id
            firstName
            lastName
          }
        }
        xml
        pdf
        reference
        emisor {
          id
        }
        location {
          id
          name
        }
        orderTotal

        createdAt
        updatedAt
      }
    }
  }
`;

const GET_LOCATIONS = gql`
  query getLocations($params: QueryParams, $name: String) {
    locations(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
      }
    }
  } 
`;

const GET_CLIENTS = gql`
  query GetClients($params: QueryParams, $search: String) {
    clients(params: $params, search: $search) {
      results {
        id
        user {
          firstName
          lastName
        }
      }
    }
  }
`;

const CREATE_INVOICE_GENERAL = gql`
  mutation CreateInvoiceGeneral($month: Int!, $xml: String, $pdf: String, $reference: String, $location: ID) {
    createInvoiceGeneral(month: $month, xml: $xml, pdf: $pdf, reference: $reference, location: $location) {
      success
      message
      invoice {
        id
      }
    }
  }
`;

const GET_ORDERS = gql`
  query orders(
    $params: QueryParams
    $client: QueryOperators
    $location: QueryOperators
    $requiredInvoice: Boolean
  ) {
    orders(
      params: $params
      client: $client
      location: $location
      requiredInvoice: $requiredInvoice
    ) {
      info {
        count
      }
      results {
        id
        client {
          id
          user {
            id
            firstName
            lastName
          }
          fiscalData {
            name
            rfc
            email
            regimenFiscal
            usoCFDI
            address {
              country
              city
              state
              street
              postcode
              colony
              internalNumber
              exteriorNumber
            }
          }
        }
        location {
          id
          name
        }
        total
        invoice {
          id
        }
      }
    }
  }
`;

export { GET_INVOICES, GET_CLIENTS, GET_LOCATIONS, CREATE_INVOICE_GENERAL, GET_ORDERS };
